<div class="page-container">
	<kwo-community-header></kwo-community-header>

	<div class="page-content">
		<router-outlet></router-outlet>
	</div>

	<kwo-footer></kwo-footer>
</div>